import { ref } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { RESOURCE_TYPE } from '@/Shared/feedConstants'

/**
 * Composable for managing URL push state for Google AdSense
 *
 * Pushes ?v={videoId} to history when video changes to trigger
 * Google AdSense to recognize each video as a new page view.
 *
 * Rate-limited using ads_interval (swipes) and ads_pause (time in ms)
 * to avoid Google penalties.
 */
export function useAdSenseNavigation() {
    const settings = usePage().props.settings

    // Rate limiting state
    let lastAdOpportunity = Date.now()
    let swipesSinceLastAd = 0
    const currentVideoId = ref(null)

    const onPostActive = (post) => {
        // Only trigger if Google AdSense is enabled and client ID is set
        if (!settings.google_ads_enabled || !settings.google_ads_client_id) return

        // Skip if it's an ad, not a post
        if (post.resource === RESOURCE_TYPE.AD) return

        // Skip if same video
        if (post.uuid === currentVideoId.value) return

        currentVideoId.value = post.uuid
        swipesSinceLastAd++

        // Only push URL when both conditions are met:
        // 1. Enough swipes have passed (google_ads_url_change_interval)
        // 2. Enough time has passed (google_ads_url_change_delay in seconds)
        const now = Date.now()
        const minSwipes = settings.google_ads_url_change_interval || 5
        const minTimeSeconds = settings.google_ads_url_change_delay || 30
        const minTimeMs = minTimeSeconds * 1000

        if (swipesSinceLastAd >= minSwipes && (now - lastAdOpportunity) >= minTimeMs) {
            // Reset counters
            lastAdOpportunity = now
            swipesSinceLastAd = 0

            window.location.href = `${window.location.pathname}?v=${post.uuid}`
        }
    }

    return { onPostActive }
}
